import { TypesSortie } from '@/enum/AAT.enum';

export class Sortie {
	autorisation: TypesSortie;
	date: string;
	raison: string;
	isRecap: boolean;

	constructor(
		autorisation: TypesSortie = TypesSortie.HORAIRES_LIMITES,
		date: string = '',
		raison: string = '',
		isRecap: boolean = false
	) {
		this.autorisation = autorisation;
		this.date = date;
		this.raison = raison;
		this.isRecap = isRecap;
	}
}

export interface SortieState {
	sortie?: Sortie;
}
